<template>
  <div>
   <div v-if="error_message" class="error-panel home-error">{{ error_message }}</div>
   <transition name="component-fade" mode="out-in">
      <start-page :is="view"
        :ticket="ticket"
        :customers="customers"
        :meta="meta"
        :customer="customer"
        :agreements="agreements"
        :agreement="agreement"
        :agreementProfs="agreementProfs"
        :procedure="procedure"
        :professional="professional"
        :schedulings="schedulings"
        :reqs="requisitions"
        :returns="returns"
        :suggestions="suggestions"
        :isLoadingAgreement="loading_agreement"
        @buttonClicked="nextSection($event)"
        @backClicked="backSection($event)"
        @setPriority="syncPriority($event)"
        @setPhoto="syncPhoto($event)"
        @foundCustomer="clientFound($event)"
        @setMeta="syncSearchCustomerMeta($event)"
        @setCustomer="syncCustomer($event)"
        @setCustomerName="syncCustomerName($event)"
        @setAgreement="syncAgreement($event)"
        @setProfessional="syncProfessional($event)"
        @setTicket="ticketCreated($event)"
        @setRequisitions="syncReqs($event)"
        @clearCustomer="clearCustomer($event)"
      >
      </start-page>
    </transition>
  </div>
</template>
<script>
import moment from 'moment';
import StartPage from './StartPage';
import NameInput from './NameInput';
import TakePicture from './TakePicture';
import CustomerIdent from './CustomerIdent';
import CustomerPriority from './CustomerPiority';
import AgreementsList from './AgreementsList';
import ProfsList from './ProfessionalsList';
import ProfAvailability from './ProfAvailability';
import FinishTicket from './FinishTicket';
import CheckinCpf from './CheckinCpf';
import CheckinTel from './CheckinTel';
import CheckinCustomers from './CheckinCustomers';
import FinishCheckin from './FinishCheckin';
export default {
  components: {
      StartPage,
      CustomerPriority,
      NameInput,
      TakePicture,
      CustomerIdent,
      AgreementsList,
      ProfsList,
      ProfAvailability,
      FinishTicket,
      CheckinCpf,
      CheckinTel,
      CheckinCustomers,
      FinishCheckin
  },
  data() {
    return {
      loading_agreement:false,
      error_message: '',
      view: 'StartPage',
      agreements: [],
      procedure: {},
      professionals: [],
      customers: [],
      meta: {},
      customer: {
        id: 0,
        name: '',
        image: '',
      },
      agreement: {},
      agreementProfs: [],
      professional: {},
      horarios: [],
      arrDays: [],
      schedulings: [],
      ticket: {
        started_at: '',
        attendance_type_id: '',
        name: '',
        photo: '',
        weight: 0,
        source: '0', //onde esta sendo gerado o ticket: 0-kiosk 1-internet 2-pré-atendimento 3-atendimento
        agreement_id: 0,
        procedure_id: 0,
        professional_id: 0,
        procedure_id: '',
        status: 'EE',
        source: 0
      },
      requisitions: [],
      returns: [],
      suggestions: []
    }
  },
  mounted() {
    this.getAgreements();
    this.getProfessionals();
    // teste base url
    console.log('baseurl:', this.$baseUrl)
  },
  methods: {
    clearCustomer() {
      this.customer = {
        id: 0,
        image: '',
        name: ''
      };
      this.returns = [];
      this.professional = {};
      this.ticket = {
        started_at: '',
        attendance_type_id: '',
        name: '',
        photo: '',
        weight: 0,
        source: '0', //onde esta sendo gerado o ticket: 0-kiosk 1-internet 2-pré-atendimento 3-atendimento
        agreement_id: 0,
        procedure_id: 0,
        professional_id: 0,
        procedure_id: '',
        status: 'EE',
        source: 0
      }
      this.agreement = {}
      this.agreementProfs = []
    },
    getAgreements() {
      axios.get('api/kiosk/agreements/99999')
      .then(({data}) => {
        this.agreements = data.data;
      }).catch((err) => {
        //this.error_message = 'Não foi possível carregar os convênios. Verifique a conexão.';
      });
    },
    getProfessionals() {
      axios.get('api/kiosk/professionals/99999')
      .then(({data}) => {
        this.professionals = data.data;
      }).catch((err) => {
        //this.error_message = 'Não foi possível carregar os profissionais. Verifique a conexão.';
      });
    },
    backSection(elem) {
      this.view = elem;
      this.agreement = {};
      this.agreementProfs = [];
      this.customer = {
        id: 0,
        name: '',
        image: '',
      };
      this.customers = [];
      this.returns = [];
      this.professional = {};
      this.schedulings = [];
      let newTicket = {
        started_at: '',
        attendance_type_id: 0,
        name: '',
        photo: '',
        weight: 0,
        agreement_id: 0,
        procedure_id: null,
        professional_id: null,
        procedure_id: '',
        status: 'EE',
        source: 0
      };
      this.ticket = newTicket;
      var utterThis = new SpeechSynthesisUtterance('Seu atendimento foi cancelado.');
      var voices = speechSynthesis.getVoices();
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      window.speechSynthesis.speak(utterThis);
    },
    nextSection(elem) {
      this.error_message = '';
      console.log(elem);
      if (elem == 'consulta' || elem == 'exame') {
        this.view = 'CustomerPriority';
        if (elem == 'consulta') {
          this.ticket.attendance_type_id = 1;
        } else if (elem == 'exame') {
          this.ticket.attendance_type_id = 2;
          this.ticket.procedure_id = null;
        }
      } else {
        this.view = elem;
      };
    },
    syncPriority(elem) {
      this.ticket.weight = elem;
    },
    clientFound(elem) {
      this.customers = elem;
    },
    syncSearchCustomerMeta(elem) {
      this.meta = elem;
    },
    syncCustomer(elem) {
      this.customer = elem;
      if (elem.agreement_id != null) {
        this.syncAgreement(elem.agreement_id);
      }
      this.ticket.agreement_id = elem.agreement_id;
    },
    syncCustomerName(elem) {
      this.customer.name = elem;
    },
    syncPhoto(elem) {
      this.ticket.photo = elem;
    },
    syncAgreement(id) {
      this.ticket.agreement_id = id;
      this.loading_agreement = true
      this.agreement = {}
      this.agreementProfs = [];
      axios.get('api/kiosk/agreement/' + id)
      .then(({data}) => {
        this.agreement = data.data;
        // Setando consulbuttonClickedta padrão
        let proc = data.data.procedures.find(function(elem, i, array) {
          return elem.cbhpm_code == '10101012'
        })
        if (proc) {
          this.procedure = proc;
        }
        //
        this.agreementProfs = [];
        data.data.professionals.map((value, i) => {
          if (value.appointment == true && value.active == true) {
            this.agreementProfs.push(value);
          }
        });
        this.loading_agreement = false
      }).catch((err) => {
        this.loading_agreement = false
        //this.error_message = 'Não foi possível carregar os dados do convênio. Tente novamente.';
      });
    },
    syncProfessional(elem) {
      this.ticket.professional_id = elem.id;
      this.professional = elem;
      // setando consulta do profissional
      var find = elem.procedures_prof.find(function(proc, i, array) {
        return proc.cbhpm_code == '10101012'
      });
      if (!find) {
        this.error_message = 'Este profissional não possui o procedimento de consulta configurado.';
        this.view = 'StartPage';
        return;
      }
      this.ticket.procedure_id = find.id;
      // pegando horarios
      this.getSuggestions(elem)
    },
    getSuggestions(prof) {
      let date = moment().format('YYYY-MM-DD')
      let obj = {
        prof_cpf: prof.cpf,
        date: date,
        customer_id: this.customer.id,
        customer_cpf: '',
        birth: '',
        agr_name: '',
        agreement_id: this.agreement.id
      }

      axios.post('api/kiosk/suggestions/professional', obj)
      .then(({data}) => {
        console.log('data', data)
        this.suggestions = data
        this.nextSection('ProfAvailability');
      }).catch((err) => {
        //this.error_message = 'Não foi possível consultar os horários. Escolha o profissional novamente.';
        this.view = 'StartPage';
      });
    },
    getAvailability() {
      var app = this;
      var qtd_days = 40;
      this.arrDays = [];
      this.schedulings = [];

      for (var index = 0; index < qtd_days; index++) {
        let daysForward = new moment().add(index, 'day');
        let day = daysForward.format('d');

        let find = this.horarios.find(function(elem, i, array) {
            return elem.day == day;
        });
        if (find) {
          let date = daysForward.format('Y-MM-DD');
          let obj = {
            date: date,
            horario: find
          }
          this.arrDays.push(obj);
          axios.get('api/kiosk/scheduling/schedulingworktime/' + this.professional.id + '/' + date + '/' + this.ticket.procedure_id)
          .then(({data}) => {
            data.map((value, i) => {
              if ('scheduling' in value) {
                var last_schedule = value.scheduling[value.scheduling.length - 1];
                if (last_schedule.time_end_booked < value.time_out) {
                  this.schedulings = this.schedulings.concat(value.scheduling[value.scheduling.length - 1]);
                }
              } else {
                this.schedulings = this.schedulings.concat({
                  date_scheduling: obj.date,
                  time_end_booked: value.time_in
                });
              }
            });
          }).catch((err) => {
            console.log(err);
          });
        };
        if (index == 14) {
          this.nextSection('ProfAvailability');
        };
      };
    },
    ticketCreated(elem) {
      console.log('ticket criado:', elem);
    },
    syncReqs(data) {
      this.requisitions = data;
    }
  }
}
</script>
<style scoped>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
.home-error {
  position: relative;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue